@if (placeholder !== undefined) {
  <div class="action-bar" #ActionBarContainer
    [style.top]="targetRegion.y + 'px'"
    [style.left]="targetRegion.x + 'px'"
    [style.width]="targetRegion.width + 'px'"
    [style.height]="targetRegion.height + 'px'"
    [style.transform]="'rotate(' + targetRegion.rotation + 'deg)'"
    >
    <div class="trigger-group"
      #triggersRef
      [ngStyle] = "{
      'left': triggerGroup.left,
      'top': triggerGroup.top,
      'transform': 'translate('
      + triggerGroup.alignHorizontal
      + ', '
      + triggerGroup.alignVertical
      + ')'
      }"
      >
      <div class="trigger-inner-wrapper">
        @for (trigger of triggerGroup.triggers; track $index) {
          <div
            class="trigger"
            [class.rotation-trigger]="trigger.action === 'rotate'"
            [class.active]="trigger.isActive"
            [title]="trigger.hoverTextKey | translate"
            (click)="triggerClicked(trigger.action)"
            >
            <mat-icon class="trigger-icon" [svgIcon]="trigger.icon"
              [style.transform]="'rotate(' + -targetRegion.rotation + 'deg)'"
            ></mat-icon>
          </div>
        }
      </div>
    </div>
    @if (rotationGroup) {
      <div class="trigger-group"
        [ngStyle] = "{
        'left': rotationGroup.left,
        'top': rotationGroup.top,
        'transform': 'translate('
        + rotationGroup.alignHorizontal
        + ', '
        + rotationGroup.alignVertical
        + ')'
        }"
        >
        <div class="trigger-inner-wrapper">
          @for (trigger of rotationGroup.triggers; track $index) {
            <div class="trigger rotation-trigger"
              [title]="trigger.hoverTextKey | translate">
              <mat-icon class="trigger-icon" [svgIcon]="trigger.icon"
                [style.transform]="'rotate(' + -targetRegion.rotation + 'deg)'"
              ></mat-icon>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
